module.exports = __webpack_public_path__ + "img/bg05.f54ddf9d.png";